const INITIAL_STATE = {
  contacts: []
};

const InitialState = { INITIAL_STATE };

export default InitialState;